export default function FileServiceProvider() {
  this.$get = ($alert, $t) => {
    'ngInject';

    function FileService() {

      const self = this;
      const mimePdf = 'application/pdf';
      const mimeImages = 'image/';

      self.isValidFile = (file, mimeTypes) => {
        if (!file) {
          return false;
        }

        if (file.$error) {
          if (file.$error === 'pattern') {
            $alert.error($t('shared.files.invalid_format_error_message', {error: file.$errorParam}));
          } else {
            $alert.error($t('shared.files.file_not_supported_error_message'));
          }
          return false;
        }

        if (!self.isCorrectSize(file.size)) {
          $alert.error($t('shared.files.max_file_size_error_message'));
          return false;
        }

        if (mimeTypes) {
          const contentType = file.contentType ? file.contentType : file.type;
          for (let i = 0; i < mimeTypes.length; i++) {
            if (contentType.match(mimeTypes[i])) {
              return true;
            }
          }

          $alert.error($t('shared.files.unsupported_file_format_error_message'));
          return false;
        }

        return true;
      };

      self.isCorrectSize = fileSize => fileSize > 0 && fileSize <= 10000000;

      self.isImage = fileType => fileType.match(mimeImages);

      self.isPdf = fileType => fileType.match(mimePdf);

      self.isValidCsvFile = file => {
        if (!file) {
          return false;
        }

        if (file.$error) {
          if (file.$error === 'pattern') {
            $alert.error($t('shared.files.invalid_format_error_message', {error: file.$errorParam}));
          } else {
            $alert.error($t('shared.files.file_not_supported_error_message'));
          }

          return false;
        }

        const contentType = file.contentType ? file.contentType : file.type;
        if (!contentType.match('csv') && !contentType.match('excel')) {
          $alert.error($t('shared.files.unsupported_file_format_error_message'));
          return false;
        }

        return true;
      };

    }

    return new FileService();
  };
}